<template>
    <main id="mainCtrl">
        <Service ref="serviceDialog" :servicesTree="servicesTree" :categories="categories" :is-network="isNetwork"/>

        <header v-if="hasPricelist && !isMedflex">
            <button @click.prevent="addService">
                <i class="far fa-plus-circle"></i> Добавить услугу
            </button>
        </header>

        <v-table id="table"
                 :request-uri="isNetwork ? ('services/getPricelist?clinic_id=' + clinicId) : 'pricelist/getList'"
                 pagesize="100"
                 ref="table">
            <template v-slot:header>
                <v-tr>
                    <v-th width="280" name="category" title="Категории">
                        Категория
                    </v-th>
                    <v-th minwidth="400" name="name_with_description" title="Название и Описание">
                        Название и Описание
                    </v-th>
                    <v-th width="120" name="mixedPrice" title="Цена">
                        Цена
                    </v-th>
                    <v-th width="450" name="tags" title="Теги">
                        Теги
                    </v-th>
                    <v-th v-if="!isMedflex" width="25" name="manualAction" title="Удаление строки" v-tooltip="{content: 'Удалить строку прайс-листа'}" >
                        С
                    </v-th>
                </v-tr>
                <v-tr>
                    <v-th name="category" v-slot="{filter}">
                        <v-select
                            v-model="filter.value"
                            :options='[
                                {
                                    value: "",
                                    text: "\u00a0"
                                },
                             ...categories.map(row => {
                                return {
                                    value: row,
                                    text: row
                                };
                             })
                        ]'
                        ></v-select>
                    </v-th>
                    <v-th name="name_with_description" :debounce="true" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="mixedPrice" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th name="tags" v-slot="{filter}">
                        <v-input v-model="filter.value" />
                    </v-th>
                    <v-th v-if="!isMedflex" name="manualAction"/>
                </v-tr>
            </template>

            <template v-slot:row="{ item, index }">
                <v-tr @click="(row, event) => handleRowClick(event, item, row)">
                    <v-td name="category" width="280">
                        <span>{{ item.category.length > 0 ? item.category[0] : '----' }}</span>
                    </v-td>
                    <v-td name="name_with_description" minwidth="400">
                        <span>{{ item.name }}</span>
                        <template v-if="item.description">
                            <br>
                            {{ item.description }}
                        </template>
                    </v-td>
                    <v-td name="mixedPrice" width="120" align="right">
                        <span>{{ item.mixedPrice }}</span>
                    </v-td>
                    <v-td name="tags" width="450">
                        <template v-for="service in item.services">
                            <template v-if="['ACCEPTED', 'ACCEPTED_MANUAL', 'NEW'].indexOf(service.status) !== -1">
                                <nobr>
                                    <span :class="service.status">{{ service.name }}</span>
                                </nobr>
                                <br/>
                            </template>
                        </template>
                    </v-td>
                    <v-td v-if="!isMedflex" name="manualAction" width="25" align="left">
                        <span class="trash-can" @click.stop.prevent="deleteRow(item)">
                            <i class="fa-icon fa-trash-can"></i>
                        </span>
                    </v-td>
                </v-tr>
            </template>
        </v-table>
    </main>
</template>

<script>
import Service from "@dialogs/pricelists/clinics/Service";

export default {
    components: {
        Service,
    },
    props: {
        hasPricelist: {
            type: Boolean,
            default: true,
        },
        isMedflex: {
            type: Boolean,
            default: false,
        },
        isNetwork: {
            type: Boolean,
            default: false,
        },
        clinicId: {
            type: String,
            default: null,
        },
    },
    data: function () {
        return {
            categories: [],
            servicesTree: [],
        };
    },
    mounted: function () {
        if (!this.isNetwork) {
            this.getCategories('pricelist/getCategories');
        }

        this.getServicesTree();
    },
    methods: {
        getCategories(url) {
            return this.axios.post(url, {clinic_id: this.clinicId}).then((response) => {
                this.categories = response.data;
            });
        },
        deleteRow(line){
            this.axios.post((this.isNetwork ? 'services/lines/' : 'pricelist/lines/') + line.id + '/delete' )
                .then((response) => {
                    this.$refs.table.rows.splice(this.$refs.table.rows.findIndex((row) => row.id === line.id), 1);
                    this.$refs.table.pagination.total--;
                });
        },
        handleRowClick: function (event, item, row) {
            if (this.isMedflex) {
                return;
            }
            row.startLoadingAnimation();
            let promise = this.$refs.serviceDialog.show(item.id, this.clinicId)
            promise.then(() => row.stopLoadingAnimation())
                .catch(() => row.stopLoadingAnimation());

            return promise;
        },
        addService() {
            this.$refs.serviceDialog.show(null, this.clinicId)
        },
        getServicesTree() {
            this.axios
                .get(this.isNetwork ? 'services/servicesTree' : 'pricelist/servicesTree')
                .then(response => {
                    this.servicesTree = response.data
                })
        },
    },
}
</script>

<style>
.fa-icon {
    font-family: 'Font Awesome 6 Pro';
    font-weight: 300;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    color: #a7a7a7;
}

.fa-icon:hover {
    font-weight: 900;
}

.fa-trash-can:hover{
    color: red !important;
}

.trash-can {
    display:none;
}

tr:hover .trash-can  {
    display:block;
}

i.rot {
    color: #b9bec7a3;
    animation: 2s linear 0s normal none infinite running rot;
    -webkit-animation: 2s linear 0s normal none infinite running rot;
}
@keyframes rot {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes rot {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
